<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="5" :sm="24"><a-form-item :label="labels.no"><a-input v-model.trim="query.documentNo" allow-clear :placeholder="'请输入' + labels.no" @pressEnter="load(true)" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item :label="labels.date"><a-range-picker v-model="dateRange" style="width:100%" /></a-form-item></a-col>
            <a-col :md="5" :sm="24"><a-form-item label="仓库"><a-select v-model="query.warehouseId" allow-clear placeholder="全部仓库"><a-select-option v-for="wh in warehouses" :key="wh.id" :value="wh.id">{{ wh.warehouseCode }} · {{ wh.warehouseName }}</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="4" :sm="24"><a-form-item label="状态"><a-select v-model="query.auditStatus" allow-clear placeholder="全部"><a-select-option value="audited">已审核</a-select-option><a-select-option value="reverse_audited">已反审核</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="4" :sm="24" class="erp-search-actions"><a-button type="primary" icon="search" @click="load(true)">查询</a-button><a-button icon="redo" @click="resetQuery">重置</a-button></a-col>
          </a-row>
          <a-row :gutter="24" style="margin-top:8px">
            <a-col :md="5" :sm="24"><a-form-item label="来源盘点单"><a-input v-model.trim="query.stocktakeNo" allow-clear placeholder="盘点单号" @pressEnter="load(true)" /></a-form-item></a-col>
            <a-col :md="5" :sm="24"><a-form-item label="原因"><a-select v-model="query.reasonCode" allow-clear placeholder="全部"><a-select-option v-for="item in reasons" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option></a-select></a-form-item></a-col>
          </a-row>
        </a-form>
      </div>
      <section class="erp-table-card">
        <div class="erp-table-toolbar">
          <div><h3>{{ labels.title }}</h3><p>{{ labels.desc }}</p></div>
        </div>
        <a-table :columns="columns" :data-source="rows" :loading="loading" row-key="id" bordered size="middle" :pagination="pagination" @change="tableChanged">
          <template slot="status" slot-scope="value"><a-tag :color="statusMeta(value).color">{{ statusMeta(value).text }}</a-tag></template>
          <template slot="actions" slot-scope="value, record"><a @click="openDetail(record)">查看</a></template>
        </a-table>
      </section>
    </div>

    <a-drawer :visible="visible" :width="960" :closable="false" :body-style="{ padding: 0 }" @close="close">
      <div class="erp-drawer-shell">
        <header class="erp-drawer-header">
          <div><button class="erp-back-button" type="button" @click="close"><a-icon type="arrow-left" /></button><span class="erp-drawer-kicker">查看{{ labels.short }}</span><h3>{{ form.documentNo || labels.short }}</h3></div>
          <div><a-button @click="close">关闭</a-button></div>
        </header>
        <div class="erp-drawer-content">
          <section class="erp-form-card">
            <div class="erp-base-grid">
              <label><span>{{ labels.no }}</span><a-input :value="form.documentNo" disabled /></label>
              <label><span>{{ labels.date }}</span><a-input :value="form.documentDate" disabled /></label>
              <label><span>仓库</span><a-input :value="(form.warehouseCode || '') + (form.warehouseName ? ' · ' + form.warehouseName : '')" disabled /></label>
              <label><span>来源盘点单</span><a-input :value="form.stocktakeNo || '-'" disabled /></label>
              <label><span>原因</span><a-input :value="form.reasonName || form.reasonCode" disabled /></label>
              <label><span>状态</span><a-input :value="statusMeta(form.auditStatus).text" disabled /></label>
              <label><span>成本合计</span><a-input :value="form.totalAmount" disabled /></label>
              <label class="wide"><span>备注</span><a-input :value="form.remark" disabled /></label>
            </div>
          </section>
          <section class="erp-form-card">
            <div class="erp-section-heading-row"><div><h4>明细</h4></div></div>
            <a-table :columns="lineColumns" :data-source="form.items || []" :pagination="false" row-key="id" size="small">
              <template slot="qty" slot-scope="value">{{ qtyText(value) }}</template>
            </a-table>
          </section>
        </div>
      </div>
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import { listWarehouse } from '@/api/erp/warehouse'
import { getDicts } from '@/api/system/dict/data'
import { listStockProfit, getStockProfit, listStockLoss, getStockLoss } from '@/api/erp/stock'

export default {
  name: 'ProfitLossDocumentPage',
  props: {
    direction: { type: String, required: true }
  },
  data () {
    return {
      query: {},
      dateRange: [],
      warehouses: [],
      reasons: [],
      rows: [],
      loading: false,
      visible: false,
      form: { items: [] },
      pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: t => `共 ${t} 条` }
    }
  },
  computed: {
    isProfit () { return this.direction === 'profit' },
    labels () {
      return this.isProfit
        ? { title: '盘盈单', short: '盘盈单', no: '盘盈单号', date: '盘盈日期', desc: '由库存盘点审核自动生成，本页仅查询查看。' }
        : { title: '盘亏单', short: '盘亏单', no: '盘亏单号', date: '盘亏日期', desc: '由库存盘点审核自动生成，本页仅查询查看。' }
    },
    columns () {
      return [
        { title: this.labels.no, dataIndex: 'documentNo' },
        { title: this.labels.date, dataIndex: 'documentDate', width: 120 },
        { title: '仓库', dataIndex: 'warehouseName' },
        { title: '来源盘点单', dataIndex: 'stocktakeNo', customRender: v => v || '-' },
        { title: '原因', dataIndex: 'reasonName', width: 120 },
        { title: '成本合计', dataIndex: 'totalAmount', width: 120 },
        { title: '状态', dataIndex: 'auditStatus', scopedSlots: { customRender: 'status' }, width: 110 },
        { title: '操作', scopedSlots: { customRender: 'actions' }, width: 80 }
      ]
    },
    lineColumns () {
      return [
        { title: 'SKU', dataIndex: 'skuCode', width: 140 },
        { title: '商品', dataIndex: 'skuName' },
        { title: '单位', dataIndex: 'unitName', width: 80 },
        { title: '数量', dataIndex: 'qtyBase', scopedSlots: { customRender: 'qty' }, width: 120 },
        { title: '成本单价', dataIndex: 'costPrice', width: 120 },
        { title: '成本金额', dataIndex: 'costAmount', width: 120 }
      ]
    }
  },
  created () {
    listWarehouse(true).then(res => {
      this.warehouses = (res.data || []).filter(row => row.status === 'enabled')
    }).catch(() => { this.warehouses = [] })
    getDicts(this.isProfit ? 'warehouse_profit_reason' : 'warehouse_loss_reason')
      .then(res => { this.reasons = res.data || [] }).catch(() => {})
    this.load(true)
  },
  methods: {
    statusMeta (value) {
      if (value === 'audited') return { text: '已审核', color: 'green' }
      if (value === 'reverse_audited') return { text: '已反审核', color: 'orange' }
      return { text: value || '-', color: 'blue' }
    },
    resetQuery () {
      this.query = {}
      this.dateRange = []
      this.load(true)
    },
    buildParams () {
      const params = {
        ...this.query,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.dateStart = this.dateRange[0].format('YYYY-MM-DD')
        params.dateEnd = this.dateRange[1].format('YYYY-MM-DD')
      }
      return params
    },
    load (reset) {
      if (reset) this.pagination.current = 1
      this.loading = true
      const api = this.isProfit ? listStockProfit : listStockLoss
      api(this.buildParams()).then(res => {
        const page = res.data || res
        this.rows = page.records || page.rows || []
        this.pagination.total = page.total || 0
      }).catch(e => this.$message.error((e && e.message) || '查询失败')).finally(() => { this.loading = false })
    },
    tableChanged (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.load(false)
    },
    qtyText (value) {
      return (Math.round(Number(value || 0) * 1000) / 1000).toFixed(3)
    },
    openDetail (record) {
      const api = this.isProfit ? getStockProfit : getStockLoss
      api(record.id).then(res => {
        const data = res.data || res
        data.items = (data.items || []).map(item => ({
          ...item,
          qtyBase: Math.round(Number(item.qtyBase || 0) * 1000) / 1000
        }))
        this.form = data
        this.visible = true
      }).catch(e => this.$message.error((e && e.message) || '加载详情失败'))
    },
    close () { this.visible = false }
  }
}
</script>

<style scoped>
.erp-section-heading-row { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 12px; }
.erp-base-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.erp-base-grid .wide { grid-column: 1 / -1; }
.erp-base-grid label { display: flex; flex-direction: column; gap: 6px; }
</style>
